<app-header></app-header>
<div id="auth" class="container-fluid">
  <div id="box_auth">
    <form action="" method="post">
      <div class="title_auth">{{'RegisterTitle' | translate}}</div>
      <div class="google-btn" (click)="loginWithGoogle()">
        <div class="google-icon-wrapper">
          <img class="google-icon" src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg">
        </div>
        <p class="btn-text">{{ 'signInWithGoogle' | translate }}</p>
      </div>
      <div class="or_line">{{ 'or' | translate }}</div>
      <div class="box_auth_row">
        <input type="mobile" id="mobile" name="mobile" placeholder="{{'MobileNumberOrEmailAddress' | translate}}" [(ngModel)]="user.username" (keyup.enter)="registerUser()">
      </div><!-- .login_row -->
      <div class="box_auth_row">
        <div class="pull-left">
          <button type="button" (click)="registerUser()">
            {{'RegisterButton' | translate}}
            <mat-spinner style="margin: 0 5px 0 0; vertical-align: middle; display: inline-block !important;" matSuffix [diameter]="20" color="accent" class="spinner" *ngIf="registerSpinner"></mat-spinner>
          </button>
        </div>
        <div class="auth_links">
          <div>
            <a [routerLink]="['/login']">{{'AdviceLogin' | translate}}</a>
          </div>
        </div>
        <div class="clearfix"></div>
      </div><!-- .login_row -->
    </form>
  </div><!-- .box_auth -->
</div><!-- #auth -->
<app-footer></app-footer>
